var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 135.075,
    height: 126.29,
    viewBox: "0 0 135.075 126.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_234",
    "data-name": "Rectangle 234",
    width: 135.075,
    height: 126.29,
    fill: "#5cc3d6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-diagnosis-time",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_386",
    "data-name": "Group 386",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_408",
    "data-name": "Path 408",
    d: "M21.372,7.144,3.234,14.072,9.007,29.179l2.261-.289L29.55,76.712a7.6,7.6,0,0,0,14.193-5.436L25.413,23.309,27.145,22.2Zm6.351,35.313-5.436,2.069-6.832-17.8,5.436-2.117Z",
    transform: "translate(12.325 27.225)",
    fill: "#5cc3d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_409",
    "data-name": "Path 409",
    d: "M47.407,101.043c-4.667,1.828-9.766-.192-11.4-4.474L7.619,23.2c-1.636-4.282.77-9.189,5.436-11.017l2.646-1.01-2.55-6.639L10.458,5.592C2.183,8.768-2.051,17.861.98,25.751L29.365,99.119c3.079,7.938,12.316,11.787,20.591,8.564L78.342,96.713a26.872,26.872,0,0,1-2.6-6.591Z",
    transform: "translate(0.001 17.278)",
    fill: "#5cc3d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_410",
    "data-name": "Path 410",
    d: "M37.084,9.861C34.053,1.922,24.816-1.926,16.493,1.3L12.644,2.788l2.55,6.639,3.849-1.491c4.667-1.828,9.766.192,11.45,4.474L51.229,66.1a27.494,27.494,0,0,1,7.217-.962Z",
    transform: "translate(48.187 0.597)",
    fill: "#5cc3d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_411",
    "data-name": "Path 411",
    d: "M6.952,28.838a2.467,2.467,0,0,0,3.223,1.4L37.551,19.648l5.2-2.021a2.485,2.485,0,0,0,1.4-1.4,2.4,2.4,0,0,0,0-1.828L41.448,7.428A4.956,4.956,0,0,0,35,4.59L30.334,6.37a9.984,9.984,0,0,0-18.619,7.217L7.1,15.367A5.015,5.015,0,0,0,4.21,21.813ZM19.269,5.312a4.995,4.995,0,1,1-2.887,6.447,5.015,5.015,0,0,1,2.887-6.447",
    transform: "translate(14.813 -0.002)",
    fill: "#5cc3d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_412",
    "data-name": "Path 412",
    d: "M12.632,3.488l.289-.144h-.337Z",
    transform: "translate(47.957 12.743)",
    fill: "#5cc3d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_413",
    "data-name": "Path 413",
    d: "M11.641,13.658a6.886,6.886,0,0,0,8.9,3.945,6.862,6.862,0,1,0-8.9-3.945",
    transform: "translate(42.647 16.574)",
    fill: "#5cc3d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_414",
    "data-name": "Path 414",
    d: "M40.774,9.7S40,6.954,34.9,6.954a26.929,26.929,0,0,0-4.763.625A38.8,38.8,0,0,0,23.55,9.552H23.5a44.692,44.692,0,0,0-6.254,2.983,20.729,20.729,0,0,0-3.9,2.694C9.5,18.645,10.8,21.195,10.8,21.195l9.766,25.45a2.734,2.734,0,0,0,5.1-1.973L17.392,23.215a.884.884,0,0,1,.481-1.058.819.819,0,0,1,1.058.481l16.117,41.9a30.867,30.867,0,0,1,3.993-9.622l-5.34-14a5.326,5.326,0,0,1,1.491-.866,5.525,5.525,0,0,1,1.78-.385L41.5,51.456a29.829,29.829,0,0,1,5.581-5.436l-11.4-29.78a.819.819,0,0,1,.481-1.058.8.8,0,0,1,1.058.433l8.227,21.457a2.725,2.725,0,0,0,5.1-1.924ZM30.141,37.841a3.378,3.378,0,0,1-3.368-3.368,3.344,3.344,0,1,1,3.368,3.368",
    transform: "translate(40.359 26.5)",
    fill: "#5cc3d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_415",
    "data-name": "Path 415",
    d: "M44.516,70.82a28.133,28.133,0,1,1,28.13-28.13,28.163,28.163,0,0,1-28.13,28.13m0-49.049A20.916,20.916,0,1,0,65.43,42.69,20.942,20.942,0,0,0,44.516,21.772",
    transform: "translate(62.429 55.468)",
    fill: "#5cc3d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_416",
    "data-name": "Path 416",
    d: "M30.038,44.743a2.417,2.417,0,0,1-1.9-.924l-6.4-8.208V19.024a2.406,2.406,0,1,1,4.811,0V33.957l5.388,6.9a2.408,2.408,0,0,1-1.9,3.887",
    transform: "translate(82.848 63.33)",
    fill: "#5cc3d6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.b873c2bd9c7515151fb295c2f74dabe6.svg";
export { ForwardRef as ReactComponent };